import UploadDocumentFileRequestModelBase from '../_generated/modelBases/upload-document-file-request-model-base';

export default class UploadDocumentFileRequestModel extends UploadDocumentFileRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
